import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";
import Base from "./Base";

const GET_COMPANY = "GET_COMPANY";

@Component
export default class CompanyMixin extends Base {
  getCompanies(params: any, tag: string) {
    const queryString = this.paramsToQueryString(params);
    const url = API_ENDPOINT + `/admin/companies.json?${queryString}`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }
  getPublicCompany(id: string) {
    const url = API_ENDPOINT + `/companies/${id}.json`;

    return this.$store.dispatch("http/request", {
      tag: GET_COMPANY,
      url: url,
      method: "GET",
    });
  }
}
